import { TransWithoutContext, useTranslation } from 'react-i18next';
import { Button, DialogTitle, IconButton, Paper, ResponsiveDialog, Stack, styled, Text } from 'shell/components';

const CourseImportOptionsDialog = ({ open, onClose, onSelectFromList, onImportById, error }) => {
    const { t } = useTranslation('course');

    return (
        <CustomResponsiveDialog aria-labelledby={'dialog-title'} open={open} onClose={onClose}>
            <DialogTitle sx={{ p: 0, width: '100%' }}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Stack sx={{ width: '100%', textAlign: 'center' }} spacing={2}>
                        <Text component={'h1'} variant={'h6'} weight={'medium'}>
                            {t('course-lobby.import-course', 'Import Course')}
                        </Text>
                        <Text variant='p2'>
                            {t('course-lobby.choose-how-to-import', 'Choose how to import your course')}:
                        </Text>
                    </Stack>
                    <IconButton
                        aria-label={'close'}
                        kind={'exit'}
                        size={'medium'}
                        variant={'square'}
                        onClick={onClose}
                        sx={{ mb: 'auto' }}
                    />
                </Stack>
            </DialogTitle>
            <Stack direction={'row'} spacing={5} justifyContent={'space-between'} sx={{ width: '100%' }}>
                <CoursePaper>
                    <Stack spacing={2} sx={{ mt: 3 }}>
                        <Text variant='p1' weight='medium'>
                            {t('course-lobby.select-course', 'Select Course')}
                        </Text>
                        <Text color='light'>
                            {t('course-lobby.pick-course-from-list', 'Pick from a list of available courses.')}
                        </Text>
                    </Stack>
                    {error?.courseName && (
                        <Text color='error' sx={{ my: 2 }}>
                            {error.courseName}
                        </Text>
                    )}
                    <Button disabled={!!error?.courseName} onClick={onSelectFromList}>
                        {t('course-lobby.select-from-list', 'Select from List')}
                    </Button>
                </CoursePaper>
                <CoursePaper>
                    <Stack spacing={2} sx={{ mt: 3 }}>
                        <Stack direction='row' alignItems='center' gap={3} justifyContent='center'>
                            <Text variant='p1' weight='medium'>
                                {t('course-lobby.course-id', 'Course ID')}
                            </Text>
                            {/* <Tooltip content={getTooltipContent()} type={'info'} /> */}
                        </Stack>
                        <Stack sx={{ px: 10 }}>
                            <Text color='error'>This feature will be available soon.</Text>
                        </Stack>
                    </Stack>
                    {error?.courseId && (
                        <Text color='error' sx={{ my: 2 }}>
                            {error.courseId}
                        </Text>
                    )}
                    <Button sx={{ mt: 2 }} variant='secondary' disabled={TransWithoutContext} onClick={onImportById}>
                        {t('course-lobby.import-by-id', 'Import by ID')}
                    </Button>
                </CoursePaper>
            </Stack>
        </CustomResponsiveDialog>
    );
};

const CoursePaper = styled(Paper)(({ theme }) => {
    return {
        width: '100%',
        minHeight: '184px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(5),
        border: `1px solid ${theme.palette.ensightful.neutral[200]}`,
        borderRadius: '16px',
        boxShadow: theme.palette.ensightful.shadows[2],
        textAlign: 'center',
    };
});

const CustomResponsiveDialog = styled(ResponsiveDialog)(({ theme }) => {
    return {
        '& .MuiDialog-paper > .MuiBox-root, & .MuiDrawer-paper > .MuiBox-root': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(8),
        },
        '& .MuiDialog-paper > .MuiBox-root': {
            width: '600px',
        },
    };
});

export default CourseImportOptionsDialog;
